/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetBillingMetadataRequestBody = {
  /**
   * Email address to notify on TUM threshold events. Omit to clear.
   */
  alertEmail?: string | undefined;
  /**
   * Day of month (1-31) the billing cycle starts, at 00:00 UTC
   */
  billingCycleAnchorDay: number;
  /**
   * The contracted monthly tokens under management limit. Omit to clear.
   */
  monthlyTokenLimit?: number | undefined;
  /**
   * The contracted tunneled MCP server source cap. Omit to leave the configured value unchanged; never-configured orgs use the plan default.
   */
  tunneledMcpServerLimit?: number | undefined;
};

/** @internal */
export type SetBillingMetadataRequestBody$Outbound = {
  alert_email?: string | undefined;
  billing_cycle_anchor_day: number;
  monthly_token_limit?: number | undefined;
  tunneled_mcp_server_limit?: number | undefined;
};

/** @internal */
export const SetBillingMetadataRequestBody$outboundSchema: z.ZodMiniType<
  SetBillingMetadataRequestBody$Outbound,
  SetBillingMetadataRequestBody
> = z.pipe(
  z.object({
    alertEmail: z.optional(z.string()),
    billingCycleAnchorDay: z.int(),
    monthlyTokenLimit: z.optional(z.int()),
    tunneledMcpServerLimit: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      alertEmail: "alert_email",
      billingCycleAnchorDay: "billing_cycle_anchor_day",
      monthlyTokenLimit: "monthly_token_limit",
      tunneledMcpServerLimit: "tunneled_mcp_server_limit",
    });
  }),
);

export function setBillingMetadataRequestBodyToJSON(
  setBillingMetadataRequestBody: SetBillingMetadataRequestBody,
): string {
  return JSON.stringify(
    SetBillingMetadataRequestBody$outboundSchema.parse(
      setBillingMetadataRequestBody,
    ),
  );
}
